/**
 * @author Evgenij Tyan
 * @version 1.0.1
 * @since 1.0.0
 */

/*
* -------------------------------------------
*           SET SELECTED FILTER
* -------------------------------------------
*/

export const SET_EXTFILTER_ID = '@@b2b_portal_ui/subscriberMobile/SET_EXTFILTER_ID';
export const SET_EXTFILTER_ID_SUCCESSFUL = '@@b2b_portal_ui/subscriberMobile/SET_EXTFILTER_ID_SUCCESSFUL';
export const SET_EXTFILTER_ID_FAILED = '@@b2b_portal_ui/subscriberMobile/SET_EXTFILTER_ID_FAILED';

/*
* -------------------------------------------
*       SET SELECTED FILTER ITEM ATTR
* -------------------------------------------
*/

export const SET_EXTFILTER_ITEM = '@@b2b_portal_ui/subscriberMobile/SET_EXTFILTER_ITEM';
export const SET_EXTFILTER_ITEM_SUCCESSFUL = '@@b2b_portal_ui/subscriberMobile/SET_EXTFILTER_ITEM_SUCCESSFUL';
export const SET_EXTFILTER_ITEM_FAILED = '@@b2b_portal_ui/subscriberMobile/SET_EXTFILTER_ITEM_FAILED';
